import React from 'react'
import styled from 'styled-components'

const Checkbox = ({ categories, selected, onChange }) => {
  return (
    <StyledWrapper>
      <div className='chips-container'>
        {categories.map((cat) => (
          <label className='chip' key={cat}>
            <input
              type='checkbox'
              checked={selected.includes(cat)}
              onChange={() => onChange(cat)}
            />
            <span>{cat}</span>
          </label>
        ))}
      </div>
    </StyledWrapper>
  )
}

const StyledWrapper = styled.div`
  .chips-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin: 12px 0 18px 0;
    justify-content: flex-start;
  }

  .chip {
    display: flex;
    align-items: center;
    background: #fff;
    border: 2px solid #0974f1;
    border-radius: 20px;
    padding: 6px 16px;
    font-size: 1em;
    font-weight: 500;
    color: #008cff;
    cursor: pointer;
    transition: background 0.2s, color 0.2s, border 0.2s;
    user-select: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  }

  .chip input[type='checkbox'] {
    display: none;
  }

  .chip input[type='checkbox']:checked + span {
    color: #fff;
    background: #0974f1;
    border-radius: 16px;
    padding: 6px 16px;
    margin: -6px -16px;
    font-weight: 600;
    transition: background 0.2s, color 0.2s;
  }

  .chip span {
    transition: background 0.2s, color 0.2s;
    padding: 0;
    border-radius: 16px;
  }

  /* Modo oscuro */
  body.dark-mode .chip,
  .app-container.dark .chip {
    background: #23272a !important;
    border-color: #0974f1 !important;
    color: #4fa3ff !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
  }
  body.dark-mode .chip input[type='checkbox']:checked + span,
  .app-container.dark .chip input[type='checkbox']:checked + span {
    background: #0974f1;
    color: #fff !important;
  }
  body.dark-mode .chip span,
  .app-container.dark .chip span {
    color: #4fa3ff !important;
  }

  @media (max-width: 600px) {
    .chips-container {
      gap: 12px;
      justify-content: flex-start;
    }
    .chip {
      font-size: 1.15em;
      padding: 10px 20px;
    }
    .chip input[type='checkbox']:checked + span {
      padding: 10px 20px;
      margin: -10px -20px;
    }
  }
`

export default Checkbox
